import type { MtoSupplierOffer } from '@entities/mto';
import { fmtConfidence, fmtDate } from '@entities/mto';
import { Badge } from '@shared/ui/Badge';
import { priceWithCurrency, supplySource } from '../helpers';
import { Muted, Table, TableScroll } from '../styles';

/**
 * Блок «Коммерческие предложения (КП)» (модуль 2.3) — read-only таблица позиций с
 * ценами поставщиков. Привязка к номенклатуре НСИ показывается бейджем с
 * уверенностью (если найдена). HITL по предложениям не предусмотрен (привязка
 * информативна); цены — строкой как есть.
 */
export function SuppliersSection({ offers }: { offers: MtoSupplierOffer[] }) {
  if (offers.length === 0) {
    return <Muted>Предложения появятся после завершения обработки.</Muted>;
  }
  return (
    <TableScroll>
      <Table>
        <thead>
          <tr>
            <th scope="col">Поставщик</th>
            <th scope="col">Наименование</th>
            <th scope="col" className="num">
              Цена
            </th>
            <th scope="col">Ед.</th>
            <th scope="col" className="num">
              Кол-во
            </th>
            <th scope="col">Действует до</th>
            <th scope="col">Справочник</th>
            <th scope="col">Источник</th>
          </tr>
        </thead>
        <tbody>
          {offers.map((o) => (
            <tr key={o.id}>
              <td>{o.supplier_name ?? '—'}</td>
              <td>{o.position_name}</td>
              <td className="num">{priceWithCurrency(o.price, o.currency)}</td>
              <td>{o.unit ?? '—'}</td>
              <td className="num">{o.quantity ?? '—'}</td>
              <td>{fmtDate(o.valid_until)}</td>
              <td>
                {o.nomenclature_id ? (
                  <Badge $tone="success">привязано · {fmtConfidence(o.match_confidence)}</Badge>
                ) : (
                  <Badge $tone="neutral">—</Badge>
                )}
              </td>
              <td>{supplySource(o.source_ref, o.source_file)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </TableScroll>
  );
}
